<template>
    <v-btn icon class="ml-2" @click="$store.dispatch('infoDialog',info)">
        <v-icon  color="indigo darken-2">mdi-information-outline</v-icon>
    </v-btn>
</template>

<script>
    export default {
        props:['info'],
        components: {},
        name: "InfoButton",
        data() {
            return {}
        }
    }
</script>

<style scoped>

</style>